
export default {
    name: 'ListDirectBanking',
    props: {
        newsItems: Array,
        newsType: String,
    },
    data() {
        return {
            contents: [],
        }
    },

    methods: {
        onClickShowDetail(id) {
            const params = {
                id,
                newsType: this.newsType,
            }

            this.$emit('detailParams', params)
        },
    },
}
